import { useMemo } from 'react';

import { APP_BREADCRUMB_HEIGHT } from './AppBreadcrumb';
import { useSidebarNav } from './SidebarNavContext';

/** Keep in sync with `--_card-gutter` in the EDS `AppLayout.css`. */
export const APP_SHELL_CARD_GUTTER = 12;

export interface AppShellInsets {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

/**
 * Viewport insets of the route card in the sidebar-nav layout, for overlay
 * content that has to occupy exactly the same box (e.g. the maximized Ask AI
 * panel). The card runs flush against the sidebar on its left and sits below
 * the breadcrumb, with the shell's gutter on the other two edges.
 *
 * `undefined` under the legacy top-nav layout, where there is no sidebar to sit
 * beside and an overlay keeps its own insets.
 */
export const useAppShellInsets = (): AppShellInsets | undefined => {
  const { width } = useSidebarNav();

  return useMemo(() => {
    if (!width) {
      return undefined;
    }

    return {
      top: APP_BREADCRUMB_HEIGHT,
      right: APP_SHELL_CARD_GUTTER,
      bottom: APP_SHELL_CARD_GUTTER,
      left: width,
    };
  }, [width]);
};
